var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgCloneSurveyIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.263 10.421h1.895v2.842H18v1.895h-2.842V18h-1.895v-2.842h-2.842v-1.895h2.842v-2.842Zm-4.737 2.842v-1.895H3.79v1.895h4.737Zm4.737-5.684H3.79v1.895h7.286a5.668 5.668 0 0 0-2.549 4.736c0 1.033.275 2.009.758 2.843h-7.39A1.894 1.894 0 0 1 0 15.158V1.895C0 .843.843 0 1.895 0h13.263a1.895 1.895 0 0 1 1.895 1.895v7.39a5.662 5.662 0 0 0-2.843-.759l-.947.076V7.58Zm0-1.895V3.79H3.79v1.895h9.474Z",
    fill: "#fff"
  })));
};
export { SvgCloneSurveyIcon as ReactComponent };
export default __webpack_public_path__ + "1e82d8480606a7e23367a1f4530456ec.svg";